if(!window.dAgency) {
    window['dAgency'] = {}
}

// Helpers
function setCookie(cname, cvalue, options) {
    var d = new Date();
    d.setTime(d.getTime() + (options.expires * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+options.path+";domain="+options.domain;
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function __GET(url, cb, json){
    var Http = new XMLHttpRequest();
    Http.open("GET", url);
    Http.send();

    if(cb) {
        Http.onreadystatechange = cb.bind(Http);
    }

  }

window.dAgency['Redirectify'] = function(domain) {
    //Do nothing if spiders
    if (/bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent)) return;
    if(_isSameReferrer(document.referrer)) return;
    var this_instance = _getInstanceByHref(document.location.href);

    var debug_mode = false;

    // Get the URL from the instance name
    function _getUrl(instance) {
	    var url = 'https://'+domain; //default instance
      if (instance == 'row') url = 'https://eu.'+domain; //ROW instance - add more rows like this if more instances
      if (instance == 'us') url = 'https://us.'+domain;
		return url;
    }

    // Map country to instance
    function _getInstanceByCountry(iso) {
	    var instance = 'it';
    	switch (iso) {
			case "IT":
				instance = 'it';
				break;
			case "EU":
			case "AD":
			case "AL":
			case "AT":
			case "BA":
			case "BE":
			case "BG":
			case "BY":
			case "CH":
			case "CS":
			case "CZ":
			case "DE":
			case "DK":
			case "EE":
			case "ES":
			case "FI":
			case "FO":
			case "FR":
			case "FX":
			case "GB":
			case "GI":
			case "GR":
			case "HR":
			case "HU":
			case "IE":
			case "IS":
			case "LI":
			case "LT":
			case "LU":
			case "LV":
			case "MC":
			case "MD":
			case "MK":
			case "MT":
			case "NL":
			case "NO":
			case "PL":
			case "PT":
			case "RO":
			case "SE":
			case "SI":
			case "SJ":
			case "SK":
			case "SM":
			case "UA":
			case "VA":
				instance = 'default';
				break;
			default:
				instance = 'us';
      }
		
    	return instance;
    }

    // Extract the instance from the URL
    function _getInstanceByHref(href) {
	    var instance = 'default'; //default instance
      if (href.indexOf(' ') > 0) instance = 'row'; //ROW instance from url - add more rows like this if more instances
      if (href.indexOf('//us.') > 0) instance = 'us';
        return instance;
    }

    function _isSameReferrer(referrer) {
        return referrer && (referrer.indexOf('//eu.'+domain) > 0 || referrer.indexOf('//us.'+domain) > 0 || referrer.indexOf('//'+domain) > 0);
    }

    function _redirect(instance, toHome = false) {
        if (instance != this_instance) {
        	if (debug_mode) {
        		return console.warn('IP REDIRECT: redirect user on ' + _getUrl(instance));
        	} else {
            var redirectUrl = _getUrl(instance);
            redirectUrl = toHome ? redirectUrl : redirectUrl + window.location.pathname;
        		return window.location = redirectUrl+window.location.search;
        	}
        }
    }

    function _setCookie(instance) {
        //console.log('set cookie instance: ' + instance);
        setCookie('instance', instance, { expires: 365, path: '/', domain: '.'+domain });
    }

    //If country in cookie, use that.
    var instance = getCookie('instance')
    if (instance && instance != this_instance) {
        _redirect(instance);
    } else {
        //If no country in cookie, use geoloc
        __GET('https://freegeoip.live/json/', function() {
            var data = JSON.parse(this.responseText);
	        var instance = _getInstanceByCountry(data.country_code);
            _setCookie(instance);
            if (instance != this_instance) {
                _redirect(instance);
                return;
            }
        });
    }
};